<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="StartPage"
    title="Default Start Page"
    submit-name="Change"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <p class="text-gray-700">
      Would you like to replace
      <span class="landscape">{{ currentDefault }}</span> by
      <span class="landscape">{{ newPage }}</span>
      as your default start page?
    </p>
  </form-modal>
</template>

<script>
import EventHub from '@/lib/eventHub'
import {mapGetters} from 'vuex'
import {AlertMessages, Events, Modal} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'

export default {
  name: 'ModalStartPage',
  components: {
    FormModal
  },
  data() {
    return {
      Events,
      modalName: Modal.START_PAGE,
      modalRef: null,
      landscapeSlug: null
    }
  },
  computed: {
    ...mapGetters(['currentLandscape', 'startPage', 'landscapes']),
    currentDefault() {
      return this.startPage === 'home'
        ? 'Home'
        : this.landscapes.find(ld => ld.slug === this.startPage).name
    },
    newPage() {
      return this.currentLandscape ? this.currentLandscape.name : 'Home'
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
  },
  methods: {
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      const slug = this.currentLandscape ? this.currentLandscape.slug : 'home'
      this.$store
        .dispatch('setStartPage', slug)
        .then(() => this.modalRef.submitSuccess())
        .catch(error => this.modalRef.submitFails(error))
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, AlertMessages.START_PAGE)
      }
    }
  }
}
</script>

<style scoped>
.landscape {
  @apply mx-1 text-highlight text-xs font-mono uppercase;
}
</style>
